import type { ChangeEventHandler, FocusEventHandler, KeyboardEventHandler, MouseEventHandler } from "react";
import type { FieldError } from "react-hook-form";
import cn from "classnames";
import { SITE_NAME } from "constants/siteName";
import { useSiteName } from "context/SiteName.context";
import styles from "./Input.module.scss";

type InputProps = {
  name?: string;
  type?: string;
  autoComplete?: string;
  value?: string;
  placeholder?: string;
  "aria-label"?: string;
  onClick?: MouseEventHandler<HTMLInputElement>;
  onBlur?: FocusEventHandler<HTMLInputElement>;
  onChange?: ChangeEventHandler<HTMLInputElement>;
  onKeyDown?: KeyboardEventHandler<HTMLInputElement>;
  error?: FieldError;
  embedded?: boolean;
  isVisiblePassword?: boolean;
  disabled?: boolean;
  className?: string;
  ref?: React.RefObject<HTMLInputElement>;
};

export const Input = ({
  name,
  type,
  autoComplete,
  value,
  placeholder,
  "aria-label": ariaLabel,
  onClick,
  onBlur,
  onChange,
  onKeyDown,
  error,
  embedded,
  isVisiblePassword,
  disabled,
  className,
  ref,
}: InputProps) => {
  const { siteName } = useSiteName();
  const isChineseBrothers = siteName === SITE_NAME.CHINESE_BROTHERS;
  const isCompleted = Boolean(value?.length);

  return (
    <input
      id={name === "city" ? "city_name" : name}
      name={name === "city" ? "city_name" : name}
      type={isVisiblePassword ? "text" : type}
      placeholder={placeholder}
      aria-label={ariaLabel}
      value={value}
      className={cn(styles["input"], className, {
        [styles["input--embedded"]]: embedded,
        [styles["input--disabled"]]: disabled,
        [styles["input--invalid"]]: error,
        [styles["input--country"]]: type === "country",
        [styles["input--password"]]: type === "password",
        [styles["input--tel"]]: type === "tel",
        [styles["input--chinese-brothers"]]: isChineseBrothers,
        [styles["input--completed"]]: isCompleted,
      })}
      onClick={onClick}
      onBlur={onBlur}
      onChange={onChange}
      onKeyDown={onKeyDown}
      disabled={disabled}
      autoComplete={autoComplete}
      ref={ref}
    />
  );
};
